
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class ProgressLinear extends Vue {
  @Prop() private active: boolean
}
